import type { AccountsWalletsTranslations } from "../interfaces/accountsWallets";

export const accountsWalletsTranslations: AccountsWalletsTranslations = {
  header_title: "Cuentas y wallets",
  header_subtitle: "Gestión de cuentas y monederos asociados a la plataforma.",
  header_hint: "Haz clic en una cuenta para ver el detalle y el historial de quién copió los datos.",
  search_placeholder: "Buscar cuentas...",
  add_account: "Añadir cuenta",
  filters_all_currencies: "Todas las monedas",
  accounts_label_singular: "1 cuenta",
  accounts_label_plural: "{{count}} cuentas",
  attachments_none: "Sin adjuntos",
  attachments_one: "1 adjunto",
  attachments_many: "{{count}} adjuntos",
  card_view_button: "Ver",
  placeholder_new_account: "Nueva cuenta",
  show_more: "Mostrar más cuentas",
  success_create: "Cuenta creada correctamente.",
  success_update: "Cuenta actualizada correctamente.",
  success_delete: "Cuenta eliminada correctamente.",
  error_delete: "No se pudo eliminar la cuenta.",
  delete_account_modal_title: "Eliminar cuenta",
  delete_account_modal_message: '¿Estás seguro de que deseas eliminar esta cuenta "{{name}}"?',
  delete_account_confirm: "Eliminar",
  card_delete_aria: "Eliminar cuenta",
  loading_accounts: "Cargando cuentas...",
  no_match_search: "No hay cuentas que coincidan con la búsqueda.",
  try_other_terms: "Prueba con otros términos o limpia el buscador.",
  no_accounts_registered: "No hay cuentas registradas",
  no_accounts_description: "Aún no tienes cuentas ni wallets asociadas. Cuando agregues una, aparecerá aquí.",
  no_match_currency: "No hay cuentas que coincidan con el filtro de moneda.",
  adjust_currency_filter: "Ajusta el filtro de moneda.",
  searching: "Buscando…",
  modal_add_title: "Añadir cuenta",
  modal_edit_title: "Editar cuenta",
  modal_create_button: "Crear cuenta",
  modal_update_button: "Actualizar cuenta",
  modal_cancel: "Cancelar",
  form_payment_bank: "Cuenta bancaria",
  form_payment_crypto: "Wallet cripto",
  form_payment_binance_pay: "Binance Pay",
  form_account_type_savings: "Cuenta de ahorros",
  form_account_type_checking: "Cuenta corriente",
  form_label_country: "País",
  form_select_country: "Seleccionar país...",
  form_currency_label: "Moneda",
  form_label_payment_method: "Método de pago",
  form_select_generic: "Seleccionar...",
  form_label_internal_alias: "Alias interno",
  form_internal_alias_placeholder: "Ej: Cuenta principal COP",
  form_label_bank_name: "Nombre del banco",
  form_select_bank: "Seleccionar banco...",
  form_label_red: "Red",
  form_select_red: "Seleccionar red...",
  form_bank_placeholder: "Ej: Bancolombia",
  form_label_account_type: "Tipo de cuenta",
  form_select_account_type: "Seleccionar tipo de cuenta...",
  form_label_account_number: "Número de cuenta",
  form_account_number_placeholder: "Ej: 1234567890",
  form_extra_methods_title: "Datos adicionales del método de pago",
  form_select_field_placeholder: "Seleccionar {{label}}...",
  form_method_option_ahorros: "Ahorros",
  form_method_option_corriente: "Corriente",
  form_method_option_cpf: "CPF",
  form_method_option_cnpj: "CNPJ",
  form_method_option_email: "Email",
  form_method_option_telefono: "Teléfono",
  form_method_option_llave_aleatoria: "Llave aleatoria",
  form_method_option_id_fps: "ID FPS",
  form_method_option_nit: "Nit",
  form_method_option_cc: "Cc",
  form_method_option_ce: "Ce",
  form_method_option_pasaporte: "Pasaporte",
  form_method_option_ppt: "Ppt",
  form_method_placeholder_clabe: "18 dígitos",
  form_label_network: "Red",
  form_select_network: "Seleccionar red...",
  form_label_wallet_address: "Dirección de la wallet",
  form_wallet_address_placeholder: "Ej: 0x71...f92a",
  form_label_notes: "Notas",
  form_notes_placeholder: "Descripción o uso de la cuenta",
  form_attachments_label: "Adjuntos",
  form_attachments_upload_edit_label: "Actualizar documentos",
  form_attachments_description: "PDF, PNG, JPG, WebP hasta 10 MB. Puedes elegir varios archivos.",
  form_documents_section_title: "Documentos",
  detail_title_fallback: "Detalle de la cuenta",
  detail_loading: "Cargando detalle...",
  detail_error_load: "No se pudo cargar el detalle de la cuenta.",
  detail_copy_history: "Historial de copias",
  detail_loading_generic: "Cargando...",
  detail_total_copies: "Total de copias",
  detail_last_copy: "Última copia",
  detail_never: "Nunca",
  detail_user: "Usuario",
  detail_times_copied: "Veces copiado",
  detail_nobody_copied: "Nadie ha copiado los datos de esta cuenta aún.",
  detail_error_load_history: "No se pudo cargar el historial de copias.",
  detail_edit_button: "Editar",
  detail_copy_bank_info: "Copiar información bancaria",
  detail_copy_info: "Copiar información",
  detail_close: "Cerrar",
  detail_copied_toast: "Información copiada al portapapeles",
  detail_error_copy_toast: "No se pudo copiar la información",
  detail_error_download_toast:
    "No se pudo descargar el archivo. El servidor debe devolver URLs pre-firmadas (pre-signed) para los adjuntos almacenados en S3.",
  detail_copied: "Copiado",
  detail_copy_button_title: "Copiar",
  detail_country: "País",
  detail_notes: "Notas",
  detail_attachments: "Adjuntos",
  detail_attachments_count: "Adjuntos ({{count}})",
  detail_file_n: "Archivo {{n}}",
  detail_download: "Descargar",
  detail_created: "Creado",
  detail_updated: "Actualizado",
  detail_bank_account: "Cuenta bancaria",
  detail_account_type_label: "Tipo de cuenta",
  detail_crypto_wallet: "Wallet Cripto",
  detail_network_label: "Red",
  detail_wallet_address_label: "Dirección de Wallet",
  detail_user_label: "Usuario",
  detail_clipboard_alias_fallback: "Cuenta",

  tracking_title: "Seguimiento cuentas",
  tracking_subtitle:
    'Listado de cuentas y wallets. Haz clic en "Ver detalle" para ver el historial de quién copió los datos.',
  tracking_search_placeholder: "Buscar por alias...",
  tracking_search_aria: "Buscar cuentas",
  tracking_button_refresh: "Actualizar",
  tracking_loading: "Cargando cuentas…",
  tracking_table_showing_one: "Mostrando 1 registro en esta página (Total: {{total}})",
  tracking_table_showing_many: "Mostrando {{count}} registros en esta página (Total: {{total}})",
  tracking_table_show_label: "Mostrar:",
  tracking_table_empty: "No hay registros para mostrar.",
  tracking_table_th_alias: "Alias",
  tracking_table_th_currency: "Moneda",
  tracking_table_th_type: "Tipo",
  tracking_table_th_created: "Creado",
  tracking_table_th_actions: "Acciones",
  tracking_table_type_wallet: "Wallet",
  tracking_table_type_bank: "Bancaria",
  tracking_table_button_view: "Ver",

  tracking_pagination_records: "Registros del {{from}} al {{to}} de {{total}}",
  tracking_pagination_total_pages: "Total de páginas ({{lastPage}})",
  tracking_pagination_first_page: "Primera página",
  tracking_pagination_prev_page: "Página anterior",
  tracking_pagination_next_page: "Página siguiente",
  tracking_pagination_last_page: "Última página",

  structured_bank: "Banco",
  structured_institution: "Institución",
  structured_account_number: "Número de cuenta",
  structured_account_type: "Tipo de cuenta",
  structured_document_type: "Tipo de documento",
  structured_document_number: "Número de documento",
  structured_llave_bre_b: "Llave Bre-B",
  structured_celular_nequi: "Número celular asociado a Nequi",
  structured_pix_key_type: "Tipo de llave Pix",
  structured_pix_key: "Llave Pix",
  structured_clabe: "CLABE (18 dígitos)",
  structured_rut: "RUT",
  structured_email: "Email",
  structured_cci: "Número CCI",
  structured_identity_document: "Documento de identidad",
  structured_celular_yape: "Número celular asociado a Yape",
  structured_celular_plin: "Número celular asociado a Plin",
  structured_bank_address: "Dirección del banco",
  structured_routing_number: "Routing number",
  structured_swift_bic: "SWIFT / BIC",
  structured_email_phone_zelle: "Email o número telefónico asociado",
  structured_iban: "IBAN",
  structured_fps_id_type: "Tipo de identificador",
  structured_fps_id: "Identificador FPS",
  structured_chats_code: "Código CHATS",
  structured_alipay_id: "ID Alipay",
  structured_wechat_id: "ID WeChat",
  structured_account_iban: "Número de cuenta IBAN",
  structured_celular: "Número celular",
  structured_cbu_cvu: "CBU o CVU",
  structured_cbu: "CBU",
  structured_cvu: "CVU",
  structured_wallet_address: "Dirección de wallet",
  structured_binance_pay_uid: "UID",
  structured_binance_pay_email: "Email",
  structured_label_fallback: "{{key}}",
};
